import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../../icons';
import './resourceLinks.css';

export default function ResourceLinks({ missionBriefUrl, pressKitUrl }) {
  if (!missionBriefUrl && !pressKitUrl) return null;

  return (
    <div className="resource-links">
      {missionBriefUrl && (
        <a
          href={missionBriefUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="resource-link resource-link--brief"
        >
          <span className="resource-link-icon">
            <FontAwesomeIcon icon={ICONS.CLIPBOARD_LIST} />
          </span>
          <span className="resource-link-label">Mission Brief</span>
          <FontAwesomeIcon icon={ICONS.EXTERNAL_LINK} className="resource-link-ext" />
        </a>
      )}
      {pressKitUrl && (
        <a
          href={pressKitUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="resource-link resource-link--kit"
        >
          <span className="resource-link-icon">
            <FontAwesomeIcon icon={ICONS.DOWNLOAD} />
          </span>
          <span className="resource-link-label">Press Kit</span>
          <FontAwesomeIcon icon={ICONS.EXTERNAL_LINK} className="resource-link-ext" />
        </a>
      )}
    </div>
  );
}
